import { render, staticRenderFns } from "./UiGiftBtn.vue?vue&type=template&id=11f58a1d"
import script from "./UiGiftBtn.vue?vue&type=script&lang=js"
export * from "./UiGiftBtn.vue?vue&type=script&lang=js"
import style0 from "./UiGiftBtn.vue?vue&type=style&index=0&id=11f58a1d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports